export default __webpack_public_path__ + "static/media/thumbnail_guide_kiki.85c83b80.png";